export default __webpack_public_path__ + "static/media/subhankar.913c3c54.JPG";